var documentWidth = $(document).width();
var sourceUrl;
var citylist;
var routeRowTemplate = ``;
// Traveller Count Form
var sum;

$(window).resize(function () {
  documentWidth = $(document).width();
});

$(function () {
  datePicker();

  radioCheckedValue = $(
    ".js-flight .js-routes-select input:radio:checked"
  ).val();
  routesTypeCheck(radioCheckedValue);

  // show more description in property
  $(".js-show-more").on("click", function () {
    $(".js-property-footer-content").toggleClass("auto-height");
    $(this).toggleClass("active");
  });

  $(".js-flight-booking-infant-info").click(function () {
    $(this)
      .closest(".js-travelers")
      .find(".js-flight-booking-infant-description")
      .slideDown();
  });

  $(".js-flight .js-auto-search").each(function () {
    autoSearch($(this));
  });

  $(".js-flight-tab").click(function () {
    routesTypeCheck(radioCheckedValue);
  });

  $(".js-flight .js-count-box .js-max").click(function () {
    var $this = $(this).closest(".js-travelers");

    if (sum < 9) {
      $this.find(".js-validation-economy").text("");

      var num = Number($(this).parent().find(".js-number-passenger").text());

      var temp = num + 1;

      var babyNumber = Number(
        $this.find(".js-passenger-infant").find(".js-number-passenger").text()
      );

      var adultNumber = Number(
        $this.find(".js-passenger-adult").find(".js-number-passenger").text()
      );

      if ($(this).closest("li").hasClass("js-passenger-adult")) {
        $(this).parent().find(".js-number-passenger").text(temp);
        $(this)
          .closest(".js-economy-target")
          .find(".js-flight-adults-number")
          .text(temp);
      } else if ($(this).closest("li").hasClass("js-passenger-infant")) {
        if (babyNumber < adultNumber) {
          $(this).parent().find(".js-number-passenger").text(temp);
          $(this)
            .closest(".js-economy-target")
            .find(".js-flight-infant-number")
            .text(temp);
        } else {
          $(".js-validation-economy").text(
            "تعداد نوزاد نمی تواند بیشتر از تعداد بزرگسال باشد"
          );
        }
      } else {
        $(this).parent().find(".js-number-passenger").text(temp);
        $(this)
          .closest(".js-economy-target")
          .find(".js-flight-child-number")
          .text(temp);
      }

      calcSum($(this).closest(".js-economy-target"));
    } else {
      $this
        .find(".js-validation-economy")
        .text("تعداد کل مسافرین نمیتواند بیشتر از 9 نفر باشد");
    }
  });

  $(".js-flight .js-count-box .js-min").click(function () {
    var $this = $(this).closest(".js-economy-target");
    $(".js-validation-economy").text("");

    var num = Number($(this).parent().find(".js-number-passenger").text());

    var min = Number($(this).parent().find(".js-number-passenger").data("min"));

    var temp = num > min ? num - 1 : num;

    var babyNumber = Number(
      $(this)
        .closest(".js-travelers")
        .find(".js-passenger-infant")
        .find(".js-number-passenger")
        .text()
    );
    var adultNumber = Number(
      $(this).parent().find(".js-number-passenger").text()
    );
    if ($(this).closest("li").hasClass("js-passenger-adult")) {
      if (babyNumber < adultNumber) {
        $(this).parent().find(".js-number-passenger").text(temp);
        $this.find(".js-flight-adults-number").text(temp);
      } else {
        $(".js-validation-economy").text(
          "تعداد بزرگسال نمی تواند کمتر از تعداد نوزاد باشد"
        );
      }
    } else if (
      $(this).closest(".js-passenger-list").hasClass("js-passenger-infant")
    ) {
      $(this).parent().find(".js-number-passenger").text(temp);
      $this.find(".js-flight-infant-number").text(temp);
    } else {
      $(this).parent().find(".js-number-passenger").text(temp);
      $this.find(".js-flight-child-number").text(temp);
    }
    calcSum($(this).closest(".js-booking-container"));
  });

  $(".js-flight .js-economy-target").each(function () {
    calcSum($(this));
  });

  //Select cabin type
  $(".js-flight .js-cabin-type").change(function () {
    $(".js-cabin-type-label").text(this.value).attr("title", $(this).val());
  });

  $(".js-routes-select").on("change", "input", function () {
    routesTypeCheck($(this).val(), $(this));
  });

  // Search Btn
  $(".js-flight button.js-flight-search").click(function () {
    $(this).closest(".js-flight").find(".error-message").remove();
    var valid = true;
    var fieldsEquelValidation = true;
    var toCityInput = $(this)
      .closest(".js-section-active")
      .find(".js-to-city")
      .attr("data-code");
    var fromCityInput = $(this)
      .closest(".js-section-active")
      .find(".js-from-city")
      .attr("data-code");

    var baseUrl = "/" + "fa" + "/flight/";

    var cabinTypeNumber = "";

    //external
    var routeType = $(this)
      .closest(".js-flight")
      .find(".js-routes-select input:checked")
      .val();

    var cabinType = $(this)
      .closest(".js-flight")
      .find(".js-cabin-type-label")
      .attr("title");

    switch (cabinType) {
      case "First":
        cabinTypeNumber = 1;
        break;

      case "Business":
        cabinTypeNumber = 2;
        break;

      case "Economy":
        cabinTypeNumber = 3;
        break;

      case "Premium":
        cabinTypeNumber = 4;
        break;
    }

    if ($(".js-search-holder .js-tab-nav").length) {
      baseUrl +=
        $(".js-search-holder .js-tab-nav")
          .find(".js-flight-tab.active")
          .attr("data-searchType") == "external"
          ? "int/"
          : "dom/";
    } else {
      baseUrl +=
        $(this).closest(".js-booking-section").attr("data-searchType") == "external"
          ? "int/"
          : "dom/";
    }

    if (fromCityInput && toCityInput && toCityInput === fromCityInput) {
      valid = false;
      fieldsEquelValidation = false;
    }
    if (routeType !== "severalWay") {
      if (fromCityInput) {
        baseUrl += fromCityInput + "-";
      } else {
        valid = false;
      }

      if ($(this).closest(".js-section-active").find(".js-to-city").data("code")) {
        baseUrl += $(this)
          .closest(".js-section-active")
          .find(".js-to-city")
          .data("code");
      } else {
        valid = false;
      }
      baseUrl += "/?Cab=" + cabinTypeNumber + "&";

      var startDatevalue = $(this).closest(".js-flight").find(".js-pick-date");

      if (startDatevalue.val() && startDatevalue.next().val()) {
        baseUrl += "Dep=" + startDatevalue.next().val();
      } else {
        valid = false;
      }

      //dom flight and rafto bargasht

      if (
        $(this)
          .closest(".js-flight")
          .find('.js-routes-select input:radio[name*="routeType"]:checked')
          .val() === "twoWay"
      ) {
        var endDateValue = $(this).closest(".js-flight").find(".js-pick-date2");

        if (endDateValue.val() && endDateValue.next().val()) {
          baseUrl += "&Ret=" + endDateValue.next().val();
        } else {
          valid = false;
        }
      }

      baseUrl +=
        "&Adt=" +
        $(this)
          .closest(".js-flight")
          .find(".js-section-active .js-passenger-adult .js-number-passenger")
          .text();

      if (
        $(this)
          .closest(".js-flight")
          .find(".js-section-active .js-passenger-child .js-number-passenger")
          .text() > 0
      ) {
        baseUrl +=
          "&Chd=" +
          $(this)
            .closest(".js-flight")
            .find(".js-section-active .js-passenger-child .js-number-passenger")
            .text();
      }
      if (
        $(this)
          .closest(".js-flight")
          .find(".js-section-active .js-passenger-infant .js-number-passenger")
          .text() > 0
      ) {
        baseUrl +=
          "&Inf=" +
          $(this)
            .closest(".js-flight")
            .find(
              ".js-section-active .js-passenger-infant .js-number-passenger"
            )
            .text();
      }
    } else if (routeType === "severalWay") {
      $(this)
        .closest(".js-flight")
        .find(".js-serveral-routes-container .js-auto-search")
        .each(function (index, value) {
          if ($(this).val() !== "") {
            var valThis = $(this).data("code");
            baseUrl += valThis;

            if (
              $(".js-serveral-routes-container .js-auto-search").length - 1 !=
              index
            ) {
              baseUrl += "-";
            }
          } else {
            valid = false;
          }
        });

      baseUrl += "/?Cab=" + cabinTypeNumber + "&";

      $(this)
        .closest(".js-flight")
        .find(".js-section-active .js-pick-date")
        .each(function (index, value) {
          if ($(this).val() !== "") {
            baseUrl += "Dep=" + $(this).next().val() + "&";
          } else {
            valid = false;
          }
        });

      baseUrl +=
        "Adt=" +
        $(this)
          .closest(".js-flight")
          .find(".js-section-active .js-passenger-adult .js-number-passenger")
          .text();

      if (
        Number(
          $(this)
            .closest(".js-flight")
            .find(".js-section-active .js-passenger-child .js-number-passenger")
            .text()
        ) > 0
      ) {
        baseUrl +=
          "&Chd=" +
          $(this)
            .closest(".js-flight")
            .find(".js-section-active .js-passenger-child .js-number-passenger")
            .text();
      }
      if (
        Number(
          $(this)
            .closest(".js-flight")
            .find(
              ".js-section-active .js-passenger-infant .js-number-passenger"
            )
            .text()
        ) > 0
      ) {
        baseUrl +=
          "&Inf=" +
          $(this)
            .closest(".js-flight")
            .find(
              ".js-section-active .js-passenger-infant .js-number-passenger"
            )
            .text();
      }
    }

    if (!valid) {
      if (!fieldsEquelValidation) {
        $(this)
          .closest(".js-flight")
          .append(
            `<span class='error-message'>فیلد مبدا و مقصد نمی‌تواند یکسان باشد</span>`
          );
      } else {
        $(this)
          .closest(".js-flight")
          .append(
            `<span class='error-message'>لطفا از فیلدها را کامل نمایید</span>`
          );
      }

      return false;
    } else {
      window.location.assign(baseUrl);
    }
  });

  // Exchange Btn For Swaping Values
  $(".js-exchange-btn").click(exchange);

  //traveller menu close
  $(document).mouseup(function (e) {
    if (
      !$(".js-economy-target").is(e.target) && // if the target of the click isn't the container...
      $(".js-economy-target").has(e.target).length === 0
    ) {
      if ($(window).width() > 992) {
        // ... nor a descendant of the container
        $(".js-travelers").fadeOut();
        $(".js-economy-target .js-booking-field").removeClass(
          "booking-search__field--active"
        );
      } else {
        $(".js-travelers").removeClass("show-tmenu");
      }
    }
  });

  ///events control in mobile
  $(".js-flight").delegate(".js-close-auto-complete", "click", function () {
    $(".js-flight-city").removeClass("show-mobile");
    $(".js-flight-search-list>ul").hide();
    $("html").removeClass("no-scroll");
  });

  // show datepicker or autocomplete list when click on parent box
  $(document).delegate(".js-booking-field", "click", function (e) {
    if ($(this).find(".js-auto-search").length) {
      if (
        !e.target.closest(".js-auto-search") &&
        !e.target.closest(".js-flight-search-list") &&
        !e.target.closest(".js-close-auto-complete")
      ) {
        $(this).find(".js-auto-search").trigger("focus");
      }
    }

    if (
      $(this).find(".js-pick-date").length &&
      !e.target.closest(".js-pick-date")
    ) {
      $(this).find(".js-pick-date.hasDatepicker").datepicker("show");
    }

    if (
      $(this).find(".js-pick-date2").length &&
      !e.target.closest(".js-pick-date2")
    ) {
      $(this).find(".js-pick-date2.hasDatepicker").datepicker("show");
    }
  });

  //search input layout in mobile
  $(".js-flight").delegate(".js-input-layout", "click", function () {
    $(this).closest(".js-flight-city").addClass("show-mobile");
    $(this).closest(".js-flight-city").find("input").trigger("focus");
    $(this).closest(".js-flight-city").find("input").trigger("search");
  });
});

//add flight in several rout
$(document).delegate(".js-add-flight-route", "click", function () {
  if ($(".js-routes-row").length <= 5) {
    var toCityValue = $(".js-routes-row").last().find(".js-to-city").val();
    var toCityValueAttr = $(".js-routes-row")
      .last()
      .find(".js-to-city")
      .attr("data-code");
    var toCitydirection = $(".js-routes-row")
      .last()
      .find(".js-to-city")
      .css("direction");

    var language = GetLanguage();

    routeRowTemplate = `
    <div class="flight-booking-inner js-routes-row js-added-flight">
        <div class="flight-booking-inner-title ">
            <label class="js-route-number hide-in-desktop">مسیر 2</label>
            <button class="flight-booking__remove js-delete-flight-route">
                <i class="icon-close"></i>
            </button>
        </div>
        <div class="flight-booking__item flight-booking__item--city js-flight-cities" data-searchtype="external">
            <div class="flight-booking__item flight-booking__item--from flight-booking__city-item js-flight-city">
                <div class="flight-booking__city-item-inner">
                    <div class="booking-search__field js-booking-field">
                        <i class="icon-airline-take-off"></i>
                        <div>
                            <div class="flight-booking__item-input-title">
                                <label>از</label>
                                <button class="js-close-auto-complete">
                                    <i class="icon-close"></i>
                                </button>
                            </div>
                            <div class="form-element-group">
                                <div>
                                <div class="search-input-layout-in-mobile js-input-layout"></div>
                                    <input type="text" data-hj-whitelist="" id="js-from-city" autocomplete="off" class="js-auto-search js-from-city js-search-filed ui-autocomplete-input">
                                    <div class="flight-booking__list js-flight-search-list"><ul id="ui-id-7" tabindex="0" class="ui-menu ui-widget ui-widget-content ui-autocomplete ui-front" style="display: none;"></ul></div>
                                    
                                </div>
                            </div>
                            <div class="flight-booking__item-loader js-search-loading">کمی صبر کنید</div>
                        </div>
                    </div>
            

                    <button class="flight-booking__exchange js-duplicate-exchange">
                        <i class="icon-exchange"></i>
                    </button>
                </div>
            </div>

            <div class="flight-booking__item flight-booking__city-item js-flight-city flight-booking__item--to">
                <div class="flight-booking__city-item-inner">
                    <div class="booking-search__field js-booking-field">
                        <i class="icon-flight-landing"></i>
                        <div>
                            <div class="flight-booking__item-input-title">
                                <label>به</label>
                                <button class="js-close-auto-complete">
                                    <i class="icon-close"></i>
                                </button>
                            </div>
                            <div class="form-element-group">
                                <div>
                                    <input type="text" data-hj-whitelist="" id="js-to-city" autocomplete="off" class="js-auto-search js-to-city js-search-filed ui-autocomplete-input">
                                    <div class="flight-booking__list js-flight-search-list"><ul id="ui-id-8" tabindex="0" class="ui-menu ui-widget ui-widget-content ui-autocomplete ui-front" style="display: none;"></ul></div>
                                </div>
                            </div>
                            <div class="flight-booking__item-loader js-search-loading">کمی صبر کنید ...</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="flight-booking__item flight-booking__item--departure rangeDates p--0">
            <div class="flight-booking__departure js-flight-departure">
                <div class="booking-search__field js-booking-field">
                    <i class="icon-check-in"></i>
                    <div>
                        <label>تاریخ رفت</label>
                        <div class="form-element-group">
                            <div>
                                <input type="text" data-hj-whitelist="" readonly="" class="js-pick-date pickDate js-search-filed" data-lang="fa">
                                <input type="hidden" value="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `;
    $(".js-routes-row").last().after($(routeRowTemplate));
    for (var i = 0; i < $(".js-route-number").length; i++) {
      var item = $(".js-route-number")[i];
      $(item).text(`مسیر ${i + 1}`);
    }

    srcType = $(this).attr("data-searchType");

    getUrl(srcType);

    setTimeout(function () {
      $(".js-flight .js-auto-search").each(function () {
        autoSearch($(this));
      });
    }, 100);

    // Function Added Maunly For Duplicated Item
    $(".js-duplicate-exchange").on("click", exchange);

    newdatePicker();
  }
});

//delete flight
$(document).delegate(".js-delete-flight-route", "click", function () {
  $(this).closest(".js-added-flight").remove();
  for (var i = 0; i < $(".js-route-number").length; i++) {
    var item = $(".js-route-number")[i];
    $(item).text(`مسیر ${i + 1}`);
  }
});

//delete all flight
$(document).delegate(".js-clear-all-flight", "click", function () {
  $(".js-added-flight").remove();
  for (var i = 0; i < $(".js-route-number").length; i++) {
    var item = $(".js-route-number")[i];
    $(item).text(`مسیر ${i + 1}`);
  }
});

//economy click
$(document).delegate(
  ".js-economy-target .js-booking-field",
  "click",
  function () {
    if ($(window).width() > 992) {
      $(this).toggleClass("booking-search__field--active");
    }

    $(this).next(".js-travelers").toggleClass("show-mobile");
    $(this).next(".js-travelers").fadeToggle();

    if (documentWidth < 992) {
      $("html").addClass("no-scroll");
    }
  }
);

//remove input text
$(document).delegate(".js-close-tmenu", "click", function () {
  $(this).closest(".js-travelers").hide();
  $("html").removeClass("no-scroll");
});

$(document).delegate(".js-search-filed", "focus", function () {
  if ($(window).width() > 992) {
    $(this)
      .closest(".booking-search__field")
      .addClass("booking-search__field--active");
  }
});

$(document).delegate(".js-search-filed", "blur", function () {
  if ($(window).width() > 992) {
    $(this)
      .closest(".booking-search__field")
      .removeClass("booking-search__field--active");
  }
});

// Functions //

// sort arrayObject
function sortArrayObject(key, order = "asc") {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    var varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    var varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    var comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order == "desc" ? comparison * -1 : comparison;
  };
}

//autoComplete
function autoSearch($this) {
  if ($($this).closest(".js-flight-cities").length) {
    if (
      $(".js-booking-section.active").attr("data-searchType") === "internal"
    ) {
      cityList = internalCityList;
    } else {
      cityList = externalCityList;
    }
  }

  $(".js-tab-nav .js-tab-nav-header .tab-link").on("click", function (e) {
    e.preventDefault();

    setTimeout(function () {
      if (
        $(".js-tab-nav").find("li.active").attr("data-searchType") ===
        "internal"
      ) {
        cityList = internalCityList;
      } else {
        cityList = externalCityList;
      }
    }, 0);
  });

  $.widget("custom.autocomplete", $.ui.autocomplete, {
    _renderMenu: function (ul, items) {
      var that = this,
        currentCategory = "";
      var sortedByFeatured = items.sort(sortArrayObject("isFeatured", "desc"));
      $.each(sortedByFeatured, function (index, item) {
        if (Object.keys(item).length) {
          that._renderItemData(ul, item);
        }
      });

      if (ul.find(".autocomplete-category-title").length === 1) {
        ul.find(".autocomplete-category-title").remove();
      }
    },

    _renderItem: function (ul, item) {
      var li = "";

      if (Object.keys(item).length) {
        var className = item.isRtl ? "rtl" : "ltr";
        ul.removeClass("rtl ltr");
        ul.addClass(className);

        if (!item.hasOwnProperty("airport")) {
          li +=
            '<li><span class="item-wrapper">' +
            '<i class="icon-pin"></i><span class="city-title">' +
            item.label +
            "</span>";

          if (item.hasOwnProperty("airports") && item.airports !== null) {
            li += '<strong class="sub-title">همه فرودگاه ها</strong>';
          } else if (
            item.hasOwnProperty("airports") &&
            item.airports === null
          ) {
            li += '<strong class="sub-title"> (' + item.code + ")</strong>";
          }

          li += "</span></li>";
        } else if (
          item.hasOwnProperty("airport") &&
          item.requestTerm != "" &&
          item.airport
        ) {
          var subdirectoryIcon = '<i class="icon-reverse-enter"></i>';
          li +=
            '<li class="airports"><div><span class="item-wrapper">' +
            subdirectoryIcon +
            '<span class="city-title"> <i class="icon-plane"></i>' +
            item.label +
            "</span>";
          li += "</span></div></li>";
        }
      }

      return $(li).appendTo(ul);
    },
  });

  $this
    .autocomplete({
      minLength: 0,
      delay: 400,
      appendTo: $this.next(),

      search: function (event) {
        $this.parent().find(".js-search-loading").show();

        if (
          $this.is(".js-to-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") ===
          "internal"
        ) {
          cityList =
            typeof destinationInternalCityList !== "undefined"
              ? destinationInternalCityList
              : internalCityList;
        }
        if (
          $this.is(".js-to-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") ===
          "external"
        ) {
          cityList =
            typeof destinationExternalCityList !== "undefined"
              ? destinationExternalCityList
              : externalCityList;
        }
        if (
          $this.is(".js-from-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") ===
          "internal"
        ) {
          cityList = internalCityList;
        }
        if (
          $this.is(".js-from-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") ===
          "external"
        ) {
          cityList = externalCityList;
        }

        if (documentWidth < 992) {
          // $(this).closest(".js-flight-city").addClass("show-mobile");
          $("html").addClass("no-scroll");
        }
        $(this).parent().find(".error-message").remove();
      },

      source: function (request, response) {
        if ($this.val() && cityList !== null) {
          var srcType = $this
            .closest(".js-flight-cities")
            .attr("data-searchType");

          getUrl(srcType);
          $this.parent().find(".js-search-loading").show();
          $.ajax({
            url: sourceUrl,
            data: {
              keyword: request.term,
              orginPlace: $($this).is(".js-from-city"),
            },

            dataType: "json",
            success: function (data) {
              $this.parent().find(".js-search-loading").hide();
              //flight
              if ($($this).closest(".js-flight-cities").length) {
                var flightsArr = [],
                  cities = {},
                  airports = {};
                response(
                  $.map(data.results, function (obj) {
                    cities = {
                      label: obj.label,
                      value: obj.cityTitle + "(" + obj.code + ")",
                      code: obj.code,
                      cityTitle: obj.cityTitle,
                      airports: obj.airports,
                      isRtl: data.isRtl,
                      isFeatured: obj.isFeatured,
                      requestTerm: request.term,
                    };
                    flightsArr.push(cities);

                    if (obj.airports != null && obj.airports.length) {
                      $.map(obj.airports, function (airport) {
                        airports = {
                          airport: true,
                          label: airport.label,
                          code: airport.code,
                          value: airport.label,
                          isRtl: data.isRtl,
                          isFeatured: obj.isFeatured,
                          cityTitle: airport.cityTitle,
                          requestTerm: request.term,
                        };

                        flightsArr.push(airports);
                      });
                    }
                    return [cities, airports];
                  })
                );
              }
            },
            error: function () {
              $this.parent().find(".js-search-loading").hide();
            },
          });
        } else {
          return response(cityList);
        }
      },

      open: function () {
        //off autocomplete in chrome
        let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
        if (chromeAgent) {
          $this.attr("autocomplete", "disable-autocomplete");
        }

        var inputObj = $this;

        inputObj
          .next(".js-flight-search-list")
          .children("ul")
          .width(
            inputObj
              .closest(".js-booking-field")
              .find(".js-auto-search")
              .width()
          );

        inputObj
          .next(".js-flight-search-list")
          .children("ul")
          .css({
            top: "+=" + 16,
          });
        inputObj
          .closest(".js-flight-cities")
          .find(".js-from-city")
          .addClass("focusedInput");
        $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");
      },

      close: function () {
        $("html").removeClass("no-scroll");
      },

      select: function (e, ui) {
        $(this).attr("data-code", ui.item.code);

        $(this).attr("data-value", ui.item.value);

        $(this).val();

        $(this).attr("placeholder", ui.item.value);

        if (
          $(this).closest(".js-serveral-routes-container").length &&
          $(this).hasClass("js-to-city")
        ) {
          if ($(this).closest(".js-routes-row").next().length) {
            if (
              !$(this)
                .closest(".js-routes-row")
                .next()
                .find(".js-from-city")
                .val()
            ) {
              if ($(window).width() > 992) {
                $(this).attr("placeholder", ui.item.value);
              }

              $(this).parent().find(".error-message").remove();
            }
          }
        }

        var routeType = $this
          .closest(".js-flight")
          .find(".js-routes-select input:checked")
          .val();

        if ($(window).width() > 992) {
          if ($(this).is(".js-from-city")) {
            $(this)
              .closest(".js-flight-cities")
              .find(".js-to-city")
              .trigger("focus");
          } else if ($(this).is(".js-to-city")) {
            if (routeType != "severalWay") {
              $(this)
                .closest(".js-section-active")
                .find(".js-pick-date")
                .trigger("focus");
            } else {
              $(this)
                .closest(".js-routes-row")
                .find(".js-pick-date")
                .trigger("focus");
            }
          }
        } else {
          $(this).closest(".js-flight-city").removeClass("show-mobile");

          $(this).autocomplete("close");

          $(this)
            .closest(".js-flight-city")
            .find(".js-input-layout")
            .html(ui.item.value);

          $("html").removeClass("no-scroll");

          $(this).autocomplete("close");

          $(this).trigger("blur");

          $this.parent().find(".js-search-loading").hide();
        }

        $(this).parent().find(".error-message").remove();
      },

      change: function (event, ui) {
        if (!ui.item) {


          if (!$(this).parent().find(".error-message").length && !flag) {
            $(this).val("");
            $(this)
              .parent()
              .append(
                `<span class="error-message">لطفا از لیست انتخاب کنید</span>`
              );
          }
        } else {
          $(this).parent().find(".error-message").remove();
        }
      },
    })

    .bind("focus", function (event) {
      if ($(this).val()) {
        flag = true;
        $(this).val("");

      }
      $(this).autocomplete("search");
      $this.parent().find(".js-search-loading").hide();
    })

    .bind("blur", function () {
      $(this).val($(this).attr("placeholder"));
      $this.parent().find(".js-search-loading").hide();
    });
}

var flag = false;

// Exchange Btn
function exchange() {
  var input1 = $(this).closest(".js-flight-cities").find(".js-from-city");
  var input2 = $(this).closest(".js-flight-cities").find(".js-to-city");

  var inputList1 = input1
    .closest(".js-flight-city")
    .find(".js-flight-search-list");
  var inputList2 = input2
    .closest(".js-flight-city")
    .find(".js-flight-search-list");

  var valueHolderInMobile1 = $(this)
    .closest(".js-flight-cities")
    .find(".js-from-city")
    .siblings(".js-input-layout");
  var valueHolderInMobile2 = $(this)
    .closest(".js-flight-cities")
    .find(".js-to-city")
    .siblings(".js-input-layout");

  $(input2).swap(input1);

  $(valueHolderInMobile2).swap(valueHolderInMobile1);

  $(inputList2).swap(inputList1);

  input1.removeClass("js-from-city").addClass("js-to-city");
  input2.removeClass("js-to-city").addClass("js-from-city");
}

// init datePicker
function datePicker() {
  setTimeout(function () {
    $(".js-flight .js-flight-departure").pickDate({
      dateFormat: "yy/mm/dd",
      dateFormatEn: "yy M dd",

      nextText: "ماه بعد",

      prevText: "ماه قبل",

      nextTextEn: "next month",

      prevTextEn: "prev month",

      changeMonthAllow: false,
      changeYearAllow: false,
      showButtonPanel: true,
      isDependenceDates: false,
      showCurrentAtPos: 0,
      numberOfMonths: $(window).width() > 991 ? 2 : 1,
      minDate: -0,
      customClass: "lightTheme",
      showAllMonthsinList: false,
      langType: "fa",
      blurInmobile: true,
      dayNamesShortFa: [
        "1شنبه",
        "2شنبه",
        "3شنبه",
        "4شنبه",
        "5شنبه",
        "جمعه",
        "شنبه",
      ],
      dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
      enterDateTitle: "تاریخ رفت",
      exitDateTitle: "تاریخ برگشت",
      enterDateTitleEn: "Departure date",
      exitDateTitleEn: "Retun date",
      fillHidden: {
        enable: true,
        outPut: "en", //en | Dependent_On_SelectedDate | fa
        customformatInhidden: "YYYY-MM-DD",
      },
      onSelectEvent: function () {
        var $this = $(this);
        var routeType = $this
          .closest(".js-flight")
          .find(".js-routes-select input:checked")
          .val();

        setTimeout(function () {
          if (routeType === "twoWay" && $this.is(".js-pick-date")) {
            $this
              .closest(".js-flight-departure")
              .find(".js-pick-date2")
              .trigger("focus");
          }
        }, 10);
      },
    });
  }, 100);
}

function newdatePicker() {
  $(".js-routes-row")
    .last()
    .find(".js-flight-departure")
    .pickDate({
      dateFormat: "yy/mm/dd",
      dateFormatEn: "yy M dd",
      changeMonthAllow: false,
      changeYearAllow: false,
      showButtonPanel: true,
      blurInmobile: true,
      isDependenceDates: false,
      customClass: "lightTheme",
      showCurrentAtPos: 0,
      numberOfMonths: $(window).width() > 991 ? 2 : 1,
      minDate: -0,
      maxDate: "+1Y",
      showAllMonthsinList: false,
      langType: "fa",

      fillHidden: {
        enable: true,
        outPut: "en", //en | Dependent_On_SelectedDate | fa
        customformatInhidden: "YYYY-MM-DD",
      },
    });
}

// get url for ajax
function getUrl(srcType) {
  if (srcType === "internal") {
    sourceUrl = "/airport/iranianairports/";
  } else if (srcType === "external") {
    sourceUrl = "/airport/airports/";
  }
}

function calcSum(obj) {
  sum = 0;
  obj.find("li.js-passenger-list .js-number-passenger").each(function () {
    sum += Number($(this).text());
    obj.find(".js-traveles-number .js-number").text(sum);
  });
}

function GetLanguage() {
  return window.location.pathname.split("/")[1];
}

function routesTypeCheck(value, obj) {
  if (value === "twoWay") {
    $(obj)
      .closest(".js-flight")
      .find(".hotel-booking__date-item--return-date")
      .show();

    $(".js-one-or-two-route-container").show().addClass("js-section-active");

    $(".js-serveral-routes-container").hide();

    $(".js-flight-departure").addClass("two-calendar");

    sum = $(
      ".js-booking-section.active .js-one-or-two-route-passengers-sum"
    ).text();
  } else if (value === "oneWay") {
    sum = $(
      ".js-booking-section.active .js-one-or-two-route-passengers-sum"
    ).text();

    // $(".js-booking-section.active .js-flight .hotel-booking__date-item--return-date").hide();

    $(obj)
      .closest(".js-flight")
      .find(".hotel-booking__date-item--return-date")
      .hide();

    $(".js-flight-departure").removeClass("two-calendar");

    $(".js-one-or-two-route-container").show().addClass("js-section-active");

    $(".js-serveral-routes-container").hide().removeClass("js-section-active");
  } else if (value === "severalWay") {
    sum = $(
      ".js-booking-section.active .js-serveral-routes-passengers-sum"
    ).text();

    $(".js-one-or-two-route-container").hide().removeClass("js-section-active");

    $(".js-flight-departure").removeClass("two-calendar");

    $(".js-serveral-routes-container").show().addClass("js-section-active");
  }
}

// Swap Elements
$.fn.swap = function (elem) {
  elem = elem.jquery ? elem : $(elem);
  return this.each(function () {
    $(document.createTextNode(""))
      .insertBefore(this)
      .before(elem.before(this))
      .remove();
  });
};
